export default {
  login: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    passwordRequired: "passwordRequired"
  },
  addSecondary:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    secondaryIdRequired: "secondaryIdRequired"
  },
  logout: {
    succeed: "logoutSucceed",
    failed: "logoutFailed"
  },
  request: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    processing: "requestProcessing",
    delayed: "requestDelayed"
  },
  session: {
    invalidToken: "session_not_exists",
    invalidSession: "session_expired",
    inactiveAccount: "account_inactive",
    invalidSession: "sessionExpired",
  },
  getBalance: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  updatePassword: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired",
    newPasswordRequired: "newPasswordRequired"
  },
  manualDeposit: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  getMemberTicketList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  addWithdrawTicket: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    withdrawal_amount_required: "withdrawal_amount_required"
  },
  getStatement: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberGameResult: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getPromo:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    dateRequired:"dateRequired"
  },
  launchWbet:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchNeko:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchLive22:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchPeg:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchKingkong:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchUuslot:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRealTimeTrans:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getNekoResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getLive22Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getKingkongResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getPegResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getUuResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getNekoGameList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  getPegGameList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  launchLg:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
};
